module.exports = __webpack_public_path__ + "img/hz.5468e64c.jpg";